import { DoctorPreference } from '../../../core/model/doctor-preference.model';

export interface DoctorPreferenceEditDialogConfig {
    treatmentId?: string;
    officeId?: string;
    treatmentTypeId?: number;
    doctorPreference?: DoctorPreference;
}
